import api from './api';

export interface ResearchPaper {
  id: string;
  user_id: string;
  title: string;
  authors: string[];
  arxiv_id?: string;
  url?: string;
  topic: 'ML' | 'CV' | 'QC' | 'QML' | 'Security';
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  status: 'To Read' | 'Reading' | 'Complete';
  reading_start_date?: string;
  reading_end_date?: string;
  time_spent_hours: number;
  summary?: string;
  key_takeaways: string[];
  code_implementations: string[];
  pass_number: number;
  created_at: string;
  updated_at?: string;
}

export interface CreatePaperData {
  title: string;
  authors?: string[];
  arxiv_id?: string;
  url?: string;
  topic: 'ML' | 'CV' | 'QC' | 'QML' | 'Security';
  difficulty?: 'Beginner' | 'Intermediate' | 'Advanced';
  status?: 'To Read' | 'Reading' | 'Complete';
}

export const papersService = {
  async getAll(status?: string, topic?: string): Promise<ResearchPaper[]> {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (topic) params.append('topic', topic);
    
    const response = await api.get(`/api/papers?${params.toString()}`);
    return response.data;
  },

  async getById(id: string): Promise<ResearchPaper> {
    const response = await api.get(`/api/papers/${id}`);
    return response.data;
  },

  async create(data: CreatePaperData): Promise<ResearchPaper> {
    const response = await api.post('/api/papers', data);
    return response.data;
  },

  async update(id: string, data: Partial<ResearchPaper>): Promise<ResearchPaper> {
    const response = await api.patch(`/api/papers/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/api/papers/${id}`);
  },
};

